// style-utils.js
import { css } from "styled-components";

export const media = {
  mobile: (...args) => css`
    @media (max-width: 766px) {
      ${ css(...args) }
    }
  `,
  mobile_500: (...args) => css`
    @media (max-width: 500px) {
      ${ css(...args) }
    }
  `,
  tablet: (...args) => css`
    @media (min-width : 767px) and (max-width : 1023px) {
      ${ css(...args) }
    }
  `,
  mobile_and_tablet: (...args) => css`
    @media (max-width : 1023px) {
      ${ css(...args) }
    }
  `,
  desktop: (...args) => css`
    @media (min-width: 1024px) and (max-width : 1439px) {
      ${ css(...args) }
    }
  `,
  desktop_plus: (...args) => css`
    @media (min-width: 1440px) {
      ${css(...args)}
    }
  `,
  mobile_plus: (...args) => css`
    @media (min-width: 500px) {
      ${css(...args)}
    }
  `,
};
